<div class="td-indicators">
  <div class="td-indicators-header">
    <span class="td-indicators-title">{{ 'td_team_report_indicators' | translate }}</span>
    <span class="td-indicators-hint">{{ 'td_team_report_indicators_hint' | translate }}</span>
  </div>

  <div class="td-indicators-list">
    <div class="td-indicator" #indicatorRow
         *ngFor="let row of rows; let index = index; trackBy: trackByUuid">
      <p-accordion collapseIcon="bi bi-chevron-up" expandIcon="bi bi-chevron-down"
                   (onOpen)="onRowOpen(row)"
                   (onClose)="onRowClose(row)">
        <p-accordionTab [selected]="selectedTabs[index]"
                        transitionOptions="300ms cubic-bezier(.25,.8,.25,1)">
          <ng-template pTemplate="header">
            <div class="td-indicator-row">
              <span class="td-indicator-chip" [ngStyle]="{'background-color': row.color}">
                <span class="td-indicator-glyph"
                      [ngStyle]="{'-webkit-mask-image': 'url(' + row.icon + ')',
                                  'mask-image': 'url(' + row.icon + ')'}"></span>
              </span>
              <span class="td-indicator-name">{{ row.title }}</span>
              <span class="td-indicator-score">{{ row.score }}%</span>
              <p-chart type="doughnut" [data]="indicatorCharts[index]" [options]="chartOptions"
                       [responsive]="true" [style]="{'width': '5rem'}"></p-chart>
              <span class="td-indicator-trend" *ngIf="row.trend" [ngClass]="row.trend">
                <img [src]="'../../../assets/svg/indicator-arrow-' + row.trend + '.svg'" alt="">
              </span>
              <span class="td-indicator-trend placeholder" *ngIf="!row.trend"></span>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <div class="td-indicator-content">
              <app-score-development class="td-indicator-chart"
                                     titleKey="td_indicator_score_over_time"
                                     [showChips]="false"
                                     [scores]="scores"
                                     [chips]="chartChips"
                                     [activeChipUuid]="openUuid"
                                     [loading]="loadingScores">
              </app-score-development>

              <app-indicator-statements [data]="statements"
                                        [loading]="loadingStatements"
                                        [responses]="statementResponses"
                                        (filtersChanged)="onStatementFiltersChanged($event)"
                                        (statementOpened)="onStatementOpened($event)">
              </app-indicator-statements>
            </div>
          </ng-template>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>

  <span class="td-indicators-empty" *ngIf="!rows.length">{{ 'td_no_data' | translate }}</span>
</div>
